import React, { Component } from "react";
import ReactTable from "react-table";
import PropTypes from "prop-types";
import "react-table/react-table.css";
import * as moment from "moment";
import "moment/locale/pt-br";
import { getInfoFinanceiraEstabelecimento } from '../providers/EstabelecimentoProvider';

const STATUS_PEDIDO = {
    CRIADO: "criado",
    RECEBIDO: "recebido",
    EM_SEPARACAO: "em_separacao",
    SEPARADO: "separado",
    LIBERADO: "liberado",
    EM_TRANSITO: "em_transito",
    CHEGOU: "chegou",
    ENTREGUE: "entregue",
    CANCELADO: "cancelado",
    ENTREGA_FINALIZADA: "entrega_finalizada"
};

export default class TBLPedidos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            detalhes_pagamento: null,
            taxa_operacao: 0,
        }
        this.columns = [
            {
                Header: "Data",
                Cell: row =>
                    row.row._original.agendado ? (
                        <span>
                            {moment(row.row._original.dataAgendamento).format("l")} {moment(row.row._original.dataAgendamento).format("LT")}
                        </span>
                    ) : (
                            <span>
                                {moment(row.row._original.createdAt).format("l")} {moment(row.row._original.createdAt).format("LT")}
                            </span>
                        ),
                className: "center"
            },
            {
                Header: "Código",
                accessor: "codigo",
                width: 120,
                className: "center"
            },
            {
                Header: "Bairro",
                accessor: "endereco_cliente",
                Cell: props => (<span>{props.value ? props.value.bairro : null}</span>),
                className: "center"
            },
            {
                Header: "Qtd itens",
                accessor: "itens",
                Cell: props => <span>{props.value.length}</span>,
                className: "center",
                width: 70,
            },
            {
                Header: "Forma Pagamento",
                accessor: "metodo_pagamento.metodo",
                Cell: props => (
                    <span>
                        {props.value === 'pagamento_na_entrega' ? 'Pagamento na Entrega' : 'Pagamento pelo App'}
                    </span>
                ),
                width: 160
            },
            {
                Header: "Meio Pagamento",
                accessor: "",
                Cell: props => <span>{this.renderMetodoPagamento(props.value)}</span>,
                width: 120,
            },
            {
                Header: "Entregador",
                accessor: "entregador",
                Cell: props => (<span>{props.value ? props.value.nome : null}</span>),
                className: "center"
            },
            {
                Header: "Frete",
                accessor: "detalhes_pagamento.frete",
                Cell: props => <span>R$ {parseFloat(props.value).toFixed(2).toString().replace('.', ',')}</span>,
                className: "right",
                width: 80,
            },
            {
                Header: "Subtotal",
                accessor: "detalhes_pagamento.subtotal",
                Cell: props => <span>R$ {parseFloat(props.value).toFixed(2).toString().replace('.', ',')}</span>,
                className: "right",
                width: 100,
            },
            {
                Header: "Total",
                accessor: "valor_total",
                Cell: props => <span>R$ {parseFloat(props.value).toFixed(2).toString().replace('.', ',')}</span>,
                className: "right",
                width: 100,
            },
            {
                Header: "Troco",
                accessor: "detalhes_pagamento.troco",
                Cell: props => <span>R$ {parseFloat(props.value).toFixed(2).toString().replace('.', ',')}</span>,
                className: "right",
                width: 100,
            },
            {
                Header: "% iFeira",
                accessor: "detalhes_pagamento.subtotal",
                Cell: props => <span>R$ {parseFloat(props.value * this.state.taxa_operacao).toFixed(2).toString().replace('.', ',')}</span>,
                className: "right",
                width: 100,
            },
            {
                Header: "% Estabelecimento",
                accessor: "detalhes_pagamento.subtotal",
                Cell: props => <span>R$ {parseFloat(props.value * (1 - this.state.taxa_operacao)).toFixed(2).toString().replace('.', ',')}</span>,
                className: "right",
                width: 150,
            },

        ];
        this.tableRef = React.createRef();
    };

    renderMetodoPagamento = (pedido) => {
        if (pedido.metodo_pagamento.tipo === "dinheiro") {
            if (pedido.detalhes_pagamento.troco) {
                return "Dinheiro com troco"
            } else {
                return "Dinheiro sem troco"
            }
        } else if (pedido.metodo_pagamento.tipo === "debito") {
            return `Débito - ${pedido.metodo_pagamento.descricao}`;
        } else if (pedido.metodo_pagamento.tipo === "credito") {
            return `Crédito - ${pedido.metodo_pagamento.descricao}`;
        }
    }

    async componentDidMount() {
        const financeiro = await getInfoFinanceiraEstabelecimento();
        if (financeiro) {
            this.setState({ taxa_operacao: financeiro.taxa_operacao });
        }
    }

    mudarBackgroundRow = status => {
        if (status === STATUS_PEDIDO.RECEBIDO) {
            return "#d8eff0";
        } else if (status === STATUS_PEDIDO.EM_SEPARACAO) {
            return "#f0f69f";
        } else if (status === STATUS_PEDIDO.SEPARADO) {
            return "#ff8a5c";
        } else if (status === STATUS_PEDIDO.LIBERADO) {
            return "#ab93c9";
        } else if (status === STATUS_PEDIDO.EM_TRANSITO) {
            return "#82acff";
        } else if (status === STATUS_PEDIDO.CHEGOU) {
            return "#b0e0a8";
        } else if (status === STATUS_PEDIDO.ENTREGUE) {
            return "#00b7a8";
        } else if (status === STATUS_PEDIDO.CANCELADO) {
            return "#d62321";
        } else if (status === STATUS_PEDIDO.ENTREGA_FINALIZADA) {
            return "#8be67c";
        } else {
            return "#f5f5f5";
        }
    };

    gerenciarAcoes = (tipo, dados) => {
        if (tipo === "ver_itens") {
            this.props.dataCallback(tipo, dados);
        } else if (tipo === "despachar_separador") {
            this.props.dataCallback(tipo, dados);
        } else if (tipo === "cancelar_pedido") {
            this.props.dataCallback(tipo, dados);
        } else {
            return;
        }
    };

    render() {
        const {
            data,
            loading
        } = this.props;
        if (data) {
            return (
                <>
                    <ReactTable
                        ref={ref => this.tableRef = ref}
                        data={this.props.data}
                        className="-striped -highlight"
                        columns={this.columns}
                        resizable
                        loading={loading}
                        style={{ maxHeight: 572 }}
                        showPagination={this.props.showPagination}
                        defaultPageSize={this.props.numRows}
                        previousText='Anterior'
                        nextText='Próximo'
                        loadingText='Carregando...'
                        noDataText='Nenhum dado encontrado!'
                        pageText='Página'
                        ofText='de'
                        rowsText='linhas'
                    />
                </>
            );
        } else {
            return (
                <div>
                    <text>Carregando...</text>
                </div>
            )
        }
    }
}

TBLPedidos.propTypes = {
    data: PropTypes.array,
    dataCallback: PropTypes.func,
    showPagination: PropTypes.bool,
    numRows: PropTypes.number,
    /* handleShowAlert: PropTypes.func,
    getPedidos: PropTypes.func,    
    pages: PropTypes.number,
    loading: PropTypes.bool,
    changePage: PropTypes.func */
};
